<template>
    <div class="card">
        <div class="card-body d-flex flex-wrap" style="gap: 10px">
            <div
                :id="`filter-${index}`"
                :class="
                    `animated


      cursor-pointer
      setscroll
      vue-filter-table ${contador.custom_class}`
                "
                :title="contador.descricao"
                v-for="(contador, index) in contadores"
                :key="index"
                @click.prevent="filterTable(index, contador.filter)"
            >
                <div
                    :id="`tile-${index}`"
                    class="tile-stats"
                    :style="{
                        'border-bottom': `2px solid ${contador.border_color ||
                            'none'}`
                    }"
                >
                    <div class="d-flex justify-content-between">
                        <div class="count">
                            {{ contador.total }}
                        </div>
                        <div class="check text" v-if="checked === index">
                            <i class="fas fa-check"></i>
                        </div>
                    </div>

                    <b v-html="contador.titulo"></b>
                </div>
            </div>

            <div
                class="d-flex align-items-center flex-row flex-wrap"
                v-if="filterSubcontadores.length > 0"
            >
                <b-button
                    size="sm"
                    v-for="(subcontador,
                    index_subcontador) in filterSubcontadores"
                    :key="index_subcontador"
                    variant="light"
                    @click.prevent="filterOnClick(subcontador.filter)"
                    style="border: 1px solid #e4e4e4"
                    class="
            m-2
            d-flex
            align-items-center
            justify-content-center
            vue-filter-table
          "
                >
                    <small
                        v-html="subcontador.titulo"
                        class="d-flex flex-row align-items-center"
                    ></small>
                    <small> ({{ subcontador.total }})</small>
                </b-button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
export default {
    name: "contador",
    data() {
        return {
            checked: 0
        };
    },
    props: {
        route: String,
        list_contadores: Array
    },
    watch: {
        current_params: function(newValue) {
            if (newValue.select && !newValue.click) {
                this.checked = 0;
            }
        },
        list_contadores() {
            this.setActive({
                contadores: this.list_contadores,
                current_route: this.$route.path
            });
        }
    },
    computed: {
        ...mapState("contador", ["contadores"]),
        ...mapState("datatable", ["current_params"]),

        filterSubcontadores() {
            if (
                this.contadores.length > 0 &&
                this.contadores[this.checked] &&
                this.contadores[this.checked].subcontadores
            )
                return this.contadores[this.checked].subcontadores;

            return [];
        }
    },
    created() {
        if (this.list_contadores) {
            this.currentFilter(this.list_contadores[0].filter);
            this.setActive({
                contadores: this.list_contadores,
                current_route: this.$route.path
            });
        } else if (this.route) {
            this.getContador(this.route);
        }
    },
    methods: {
        ...mapActions("contador", ["getContador"]),
        ...mapMutations("contador", ["setActive", "currentFilter"]),
        ...mapMutations("datatable", ["filterOnClick"]),
        // async reload(){

        // },
        filterTable(index, filter) {
            this.checked = index;
            this.currentFilter(this.list_contadores[index].filter);
            this.filterOnClick(filter);

            //this.$root.$emit("filter-table", filter_name, value);
        }
    }
};
</script>

<style lang="scss" scoped>
@media only screen and (max-width: 375px) {
    .vue-filter-table {
        width: 100%;
    }

    .tile-stats {
        width: 100%;
    }
}

.tile-stats {
    margin-bottom: 0;
    min-width: 147px;
}

.tile-stats .check {
    display: block !important;
}
</style>
